import { Injectable, OnDestroy } from '@angular/core';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityService implements OnDestroy {
  private readonly onlineSubject = new BehaviorSubject<boolean>(true);
  private listenerHandle: PluginListenerHandle | null = null;
  private initialized = false;

  readonly online$: Observable<boolean> = this.onlineSubject.asObservable();

  get isOnline(): boolean {
    return this.onlineSubject.value;
  }

  async init(): Promise<void> {
    if (this.initialized || !Capacitor.isNativePlatform()) {
      return;
    }
    this.initialized = true;

    const status = await Network.getStatus();
    this.onlineSubject.next(status.connected);

    this.listenerHandle = await Network.addListener('networkStatusChange', (event) => {
      this.onlineSubject.next(event.connected);
    });
  }

  async refreshStatus(): Promise<boolean> {
    if (!Capacitor.isNativePlatform()) {
      return true;
    }
    const status = await Network.getStatus();
    this.onlineSubject.next(status.connected);
    return status.connected;
  }

  ngOnDestroy(): void {
    void this.listenerHandle?.remove();
    this.listenerHandle = null;
  }
}
